"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { CATEGORIES, CITIES } from "@/lib/data";

export default function Filters() {
  const router = useRouter();
  const params = useSearchParams();
  const city = params.get("city") ?? "";
  const cat = params.get("cat") ?? "";

  const apply = (next: { city?: string; cat?: string }) => {
    const s = new URLSearchParams();
    const v = { city, cat, ...next };
    if (v.city) s.set("city", v.city);
    if (v.cat) s.set("cat", v.cat);
    const qs = s.toString();
    router.push(qs ? `/?${qs}#lenta` : "/", { scroll: false });
  };

  const field =
    "h-10 w-full rounded-md border border-line bg-bg px-3 text-[14px] outline-none focus:border-brand";

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      <select
        className={field}
        value={city}
        onChange={(e) => apply({ city: e.target.value })}
        aria-label="Город"
      >
        <option value="">Вся Россия</option>
        {CITIES.map((c) => (
          <option key={c.slug} value={c.slug}>
            {c.name}
          </option>
        ))}
      </select>
      <select
        className={field}
        value={cat}
        onChange={(e) => apply({ cat: e.target.value })}
        aria-label="Категория"
      >
        <option value="">Все категории</option>
        {CATEGORIES.map((c) => (
          <option key={c.slug} value={c.slug}>
            {c.name}
          </option>
        ))}
      </select>
    </div>
  );
}
